





























import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import {StavkaDokumenta, Trebovanje} from "@/services/BackendProxies";
import PretragaRezervnihDelova from "@/components/PretragaRezervnihDelova.vue";
import dataProxy from '@/services/data-proxy.service';
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({components: {'mf-pretraga-delova': PretragaRezervnihDelova}})
export default class TrebovanjeComponent extends mixins(ComponentBaseMixin) {
    @Prop() trebovanje!: Trebovanje;
    columns = [];
    dialogPretragaRezDelovaOtvoren = false;
    isBusy = false;

    @Watch('$i18n') onI18nChanged() {
        console.log('i18n changed');
    }


    onIzabranRezerniDeo(stavkaDokumenta: StavkaDokumenta) {
        if (stavkaDokumenta.kolicina) {
            this.trebovanje.stavke.push(stavkaDokumenta);
            this.showInfo('rezervni deo je dodan trebovanju');
        }
    }

    created() {
        this.columns = [
            {field: 'rezervniDeo', title: this.$i18n.t('rezervniDeo')},
            {field: 'kolicina', title: this.$i18n.t('kolicina'), align: 'right'},
            {field: 'id', formatter: id => `<i class="fa fa-trash text-danger"></i>`}
        ]
    }

    async rowClicked(stavkaDokumenta: StavkaDokumenta, $e, field) {
        if (field === 'id') {
            const da = await this.confirmationNeeded('da li zelite da obrisete trebovanje za rezervni deo');
            if (da) {
                this.trebovanje.stavke = [...this.trebovanje.stavke.filter(x => x != stavkaDokumenta)];
            }
        }
    }

    async sacuvajTrebovanje() {
        if (this.isBusy) return;
       const valid = await (<any>this.$refs.observer).validate();
       if (valid) {
           this.isBusy = true;
           try {
               await dataProxy.sacuvajTrebovanje(this.trebovanje);
           } finally {
               this.isBusy = false;
           }
       } else {
           this.showError('podaci nisu validni')
       }
    }

    otvoriPretraguDelova() {
        this.dialogPretragaRezDelovaOtvoren = true;
    }
}
